// extracted by mini-css-extract-plugin
export var cell = "_6a-4";
export var headerCell = "_6a-2";
export var rowHeader = "_6a-3";
export var table = "_6a-1";
export var tableContainer = "_6a-0";